module.exports = __webpack_public_path__ + "./fonts/PPAgrandir-TextBold.otf";